export class SupplierItem {
  id: number;
  supplierName: string;
  group: string;
  grouping: string;
  itemModel: string;
  status: string;

  /* constructor() {
    (this.id = -1),
      (this.supplierName = ''),
      (this.grouping = ''),
      (this.group = ''),
      (this.itemModel = ''),
      (this.status = '');
  }*/
  constructor(item: {
    id: number;
    supplierName: string;
    group: string;
    grouping: string;
    itemModel: string;
    status: string;
  }) {
    (this.id = item.id),
      (this.supplierName = item.supplierName),
      (this.grouping = item.grouping),
      (this.group = item.group),
      (this.itemModel = item.itemModel),
      (this.status = item.status);
  }
}
